<section class="notification" *ngIf="notification">
  <div [innerHTML]="notification.description"></div>
</section>
